import { useCrossProductUrlWrapper } from '@atlassiansox/analytics-cross-product-interaction-client';

export const useAnalyticsWrapper = (product: string) => {
	const analyticsUrlWrapper = useCrossProductUrlWrapper({
		bridge: 'appSwitcher',
		product: product ?? 'appSwitcher',
	});

	return (url: string) => {
		try {
			const parsedUrl = new URL(url);
			const continueParam = parsedUrl.searchParams.get('continue');
			if (!continueParam) {
				// If there is no continue param, we just wrap the whole URL
				return analyticsUrlWrapper(url);
			}

			// Safely deserialize identity links e.g: https://id.atlassian.com/login?login_hint=...
			const wrappedContinueUrl = analyticsUrlWrapper(continueParam);
			// Reconstruct the original URL with the wrapped continue param
			parsedUrl.searchParams.set('continue', wrappedContinueUrl);
			return parsedUrl.toString();
		} catch (e) {
			return url;
		}
	};
};
